import React, { Component } from "react";
import styles from "./winterUnits.module.scss";
import { withAuth } from "../../../shared/containers/containerAuth";
import { withWinter } from "../../../shared/containers/containerWinter";
import WinterGroups from "./WinterGroups";
import WinterUnitsToolMode from "./WinterUnitsToolMode";

class WinterUnits extends Component {
  componentDidMount() {
    const { data, onGetWinterGroups } = this.props;
  }

  render() {
    const { data } = this.props;

    if (!data.permissions.includes(38001)) {
      return null;
    }

    return (
      <div className={styles.winterUnitsPanelContainer}>
        <WinterUnitsToolMode />
        <WinterGroups />
      </div>
    );
  }
}

export default withWinter(withAuth(React.memo(WinterUnits)));
